<div class="device-login-warning-modal modal">
    <div class="modal-header">
        <h1>{{ 'deviceLoginWarning.title' | translate }}</h1>
        <mat-icon class="close" mat-dialog-close>close</mat-icon>
    </div>

    <p class="description">{{ 'deviceLoginWarning.info' | translate }}</p>

    <div class="buttons">
        <button mat-flat-button class="btn outlined" (click)="cancel()">
            {{ 'button.cancel' | translate }}
        </button>
        <button mat-flat-button class="btn default" (click)="goToDevicesManagement()">
            {{ 'deviceLoginWarning.goToDevicesManagement' | translate }}
        </button>
    </div>
</div>